const trimUrl = (value) => (value ? String(value).replace(/\/$/, "") : "");

/**
 * Backend de catálogos (agentes, remitentes/consignatarios).
 * Mismo servicio que Gestión de almacén → Catálogos (horus-backend-catalogs, :9000).
 * Reingresos/readmissions sigue en REACT_APP_URL_BACKEND_IMPO.
 */
export const getCatalogBackendUrl = () =>
  trimUrl(process.env.REACT_APP_URL_BACKEND) ||
  trimUrl(process.env.REACT_APP_URL_BACKEND_IMPO) ||
  "http://localhost:9000";

export const catalogApiUrl = (path) => `${getCatalogBackendUrl()}${path}`;

export const getImpoBackendUrl = () =>
  trimUrl(process.env.REACT_APP_URL_BACKEND_IMPO) ||
  "http://localhost:9004";

export const impoApiUrl = (path) => `${getImpoBackendUrl()}${path}`;

export const shipperConsigneeApiUrl = catalogApiUrl;
